export const MESSAGE_STATUS_CODE = "MESSAGE_STATUS_CODE"
export const MESSAGE_DATA_ERROR = "MESSAGE_DATA_ERROR"